import { useCallback, useState, useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Row, Col, Divider } from "antd";

import CustomerAlert from "../../customerAlert";
import IconButton from "../../../../app/generic/iconButton";
import { getDefaultContactForm } from "../../address/contact";
import Phone, { CzechPreselection } from "../../address/phone";
import { postEntity } from "../../../../../modules/crudOperations";
import { FingerprintContext } from "../../../../fingerprintProvider";
import { czechMobileRegex } from "../../../../../modules/dataFunctions";
import InputNumberItem from "../../../../app/generic/form/inputNumberItem";

import "./index.css";

export const smsInputId = "smsControl", smsCodeId = "smsCode";

const fullInputId = `contactPhone${smsInputId}`,
  fullInputIdPre = `contactPhonePreselection${smsInputId}`;

const regex = new RegExp(czechMobileRegex);

const checkPhone = (phone) => regex.test(phone);

export const parseInitialSmsConfirmForm = (principal) => {
  const values = getDefaultContactForm(smsInputId);
  if (principal && principal.phone && checkPhone(principal.phone)) {
    values[fullInputId] = principal.phone;
  }
  return values;
};

const SmsConfirm = ({ id, form, show, onValidation, onSetCanBeSent }) => {
  const intl = useIntl();
  const fingerprint = useContext(FingerprintContext);

  const [loading, setLoading] = useState();
  const [showCode, setShowCode] = useState();
  const [showError, setShowError] = useState();
  const [showExceed, setShowExceed] = useState();
  const [phoneError, setPhoneError] = useState();
  const handleSubmit = useCallback(() => {
    const p = new Promise((resolve) => onValidation(undefined, resolve));
    p.then((valid) => {
      if (valid) {
        const phone = form.getFieldValue(fullInputId),
          preselection = form.getFieldValue(fullInputIdPre);
        if (checkPhone(phone) && preselection === CzechPreselection) {
          setPhoneError();
          postEntity(
            "contract/sms",
            setLoading,
            { phone: preselection + phone, contractId: id, fingerprint },
            undefined,
            undefined,
            undefined,
            (_, httpCode) => {
              const valid = httpCode === 200,
                exceed = httpCode === 409;
              setShowCode(valid);
              setShowError(!valid && !exceed);
              setShowExceed(exceed);
            },
            intl.formatMessage({
              id: "registration.sms.success",
              defaultMessage: "Kód byl úspěšně odeslán na Váš telefon.",
            }),
            intl.formatMessage({
              id: "registration.sms.error",
              defaultMessage:
                "Došlo k překročení limitu odeslaných SMS, zkuste to prosím později.",
            })
          );
        } else {
          setPhoneError(
            intl.formatMessage({
              id: "registration.sms.phone.error",
              defaultMessage: "Zadejte validní české telefonní číslo.",
            })
          );
        }
      }
    });
  }, [id, intl, form, onValidation, fingerprint]);

  const handleCodeBlur = useCallback(
    (value) => {
      onSetCanBeSent(value && value.toString().length === 5 ? true : false);
    },
    [onSetCanBeSent]
  );

  return show ? (
    <>
      <CustomerAlert
        show={showError}
        textId="registration.sms.error.smsError"
        defautTextMessage="Momentálně není možné odesílat potvrzovací sms. V případě přetrvání tohoto problému kontaktujte Zákaznický servis DHL Freight CZ na telefonním čísle 239 018 222 nebo napište email na DHLFreight.CZ@dhl.com."
      />
      <CustomerAlert
        show={showExceed}
        textId="registration.sms.error.extended"
        defautTextMessage="Vážený zákazníku, překročil jste limit v zadání ověřujících SMS. Pro dokončení registrace prosím kontaktujte Zákaznický servis DHL Freight CZ na telefonním čísle 239 018 222 nebo napište email na DHLFreight.CZ@dhl.com."
      />
      <Row justify="end" align="middle" gutter={20}>
        <Col xxl={5} xl={6} md={12} sm={16} xs={24}>
          <Phone
            onlyMobile
            form={form}
            disabled={loading}
            inputId={smsInputId}
            disabledPreselection
            phoneError={phoneError}
            label={
              <FormattedMessage
                id="registration.sms.label"
                defaultMessage="Telefon pro potvrzení registrace"
              />
            }
            message={
              <FormattedMessage
                id="registration.sms.message"
                defaultMessage="Zadejte prosím validní mobilní telefonní číslo!"
              />
            }
          />
        </Col>
        <Col xxl={3} xl={3} sm={4} xs={8} className="sms-col-margin">
          <IconButton
            loading={loading}
            onClick={handleSubmit}
            text={
              showCode ? (
                <FormattedMessage
                  id="registration.sms.getCode.another"
                  defaultMessage="Znovu zaslat kód"
                />
              ) : (
                <FormattedMessage
                  id="registration.sms.getCode"
                  defaultMessage="Zaslat kód"
                />
              )
            }
          />
        </Col>
      </Row>
      {showCode && (
        <Row justify="end" align="middle" gutter={20}>
          <Col span={8}>
            <InputNumberItem
              required
              min={1}
              max={99999}
              fieldName={smsCodeId}
              onChange={handleCodeBlur}
              label={
                <FormattedMessage
                  id="registration.sms.code"
                  defaultMessage="Potvrzovací kód z SMS"
                />
              }
            />
          </Col>
        </Row>
      )}
      <Divider />
    </>
  ) : (
    <></>
  );
};

export default SmsConfirm;
